import BasicCard from "../../pages/BasicCard";
import Dummylayout from "../../pages/Dummylayout";
import SuperAdminPassword from "./SuperAdminPassword";
import UserFormToFill from "./UserFormToFill";




function SuperAdminPasswordMain () {
    return (
        <>
            <Dummylayout/>
        <BasicCard>
                <SuperAdminPassword/>
                </BasicCard>
        </>
    )
}
export default SuperAdminPasswordMain;